import React, { useState } from 'react'
import { Button, Space, message, theme } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faFileAlt, faEnvelope, faPlus } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import SaveToDocsModal from '../SaveToDocsModal'
import { saveContentToDocuments } from '../../utils/saveToDocsUtils'

const GenAIActionButtons = ({ content, onInsertToNote, bookingData, userRef }) => {
  const { token } = theme.useToken()
  const [saveToDocsModalVisible, setSaveToDocsModalVisible] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content)
      message.success('Content copied to clipboard')
    } catch (error) {
      message.error('Failed to copy content')
    }
  }

  const handleSaveToDocs = () => {
    setSaveToDocsModalVisible(true)
  }

  const handleSaveToDocsConfirm = async (documentType) => {
    setIsSaving(true)
    try {
      const newRecord = await saveContentToDocuments(content, documentType, bookingData, userRef)
      message.success(`Document "${documentType}" saved successfully to Documents section`)
      setSaveToDocsModalVisible(false)
    } catch (error) {
      message.error(`Failed to save document: ${error.message}`)
    } finally {
      setIsSaving(false)
    }
  }

  const handleEmail = () => {
    // Create email with content
    const subject = `Generated Content - ${new Date().toLocaleDateString()}`
    const body = encodeURIComponent(content)
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`

    window.open(mailtoLink, '_blank')
    message.success('Email client opened with generated content')
  }

  const handleInsertToNote = () => {
    if (onInsertToNote) {
      onInsertToNote()
      message.success('Content inserted to clinical note')
    }
  }

  const handleWhatsAppShare = () => {
    // Clean and format content for WhatsApp
    const cleanContent = content.replace(/<[^>]*>/g, '').trim() // Remove HTML tags
    const formattedContent = `Generated Content - ${new Date().toLocaleDateString()}\n\n${cleanContent}`

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(formattedContent)

    // Create WhatsApp share URL
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`

    // Open WhatsApp in new tab/window
    window.open(whatsappUrl, '_blank')
    message.success('Opening WhatsApp to share content')
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: '12px 16px',
          backgroundColor: '#fafafa',
          borderBottom: `1px solid ${token.colorBorder}`
        }}
      >
        <Space size={12}>
          <Button
            type='text'
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={handleInsertToNote}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              fontSize: '13px',
              height: '32px'
            }}
          >
            Insert as note
          </Button>

          <Button
            type='text'
            icon={<FontAwesomeIcon icon={faEnvelope} />}
            onClick={handleEmail}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              fontSize: '13px',
              height: '32px'
            }}
          >
            Email
          </Button>

          <Button
            type='text'
            icon={<FontAwesomeIcon icon={faWhatsapp} />}
            onClick={handleWhatsAppShare}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              fontSize: '13px',
              height: '32px',
              color: '#25D366' // WhatsApp green color
            }}
          >
            WhatsApp
          </Button>

          <Button
            type='text'
            icon={<FontAwesomeIcon icon={faFileAlt} />}
            onClick={handleSaveToDocs}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              fontSize: '13px',
              height: '32px'
            }}
          >
            Save to Docs
          </Button>

          <Button
            type='text'
            icon={<FontAwesomeIcon icon={faCopy} />}
            onClick={handleCopy}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 12px',
              fontSize: '13px',
              height: '32px'
            }}
          >
            Copy
          </Button>
        </Space>
      </div>

      {/* Save to Docs Modal */}
      <SaveToDocsModal
        visible={saveToDocsModalVisible}
        onCancel={() => setSaveToDocsModalVisible(false)}
        onSave={handleSaveToDocsConfirm}
        content={content}
        isLoading={isSaving}
      />
    </>
  )
}

export default GenAIActionButtons
